"use client";

import { useState } from "react";
import { clsx } from "clsx";
import NextImage from "next/image";
import { sizes } from "@ui/lib/sizes";
import { RevealImageContainer } from "@ui/components/core/RevealImageContainer";

type ImageConfig = {
  src: string;
  alt: string;
};

type ImageRevealProps = {
  agentsImage: ImageConfig;
  creativeImage: ImageConfig;
  /** Which platform image appears on the left (active by default) */
  primaryPlatform?: "agents" | "creative";
};

export function ImageReveal({ agentsImage, creativeImage, primaryPlatform = "agents" }: ImageRevealProps) {
  const [activeIndex, setActiveIndex] = useState(0);

  const leftImage = primaryPlatform === "agents" ? agentsImage : creativeImage;
  const rightImage = primaryPlatform === "agents" ? creativeImage : agentsImage;

  return (
    <div className='tw-flow-root tw-overflow-hidden lg:tw-pl-12 xl:tw-pl-20'>
      <div
        className='tw-grid tw-isolate tw-rounded-tl-3xl tw-overflow-hidden'
        style={{
          gridTemplateColumns: "60% 30% 60%",
        }}
      >
        <RevealImage
          src={leftImage.src}
          alt={leftImage.alt}
          position='left'
          isActive={activeIndex === 0}
          onHoverStart={() => setActiveIndex(0)}
          className='tw-col-start-1'
        />

        <RevealImage
          src={rightImage.src}
          alt={rightImage.alt}
          position='right'
          isActive={activeIndex === 1}
          onHoverStart={() => setActiveIndex(1)}
          className='tw-col-start-2'
        />
      </div>
    </div>
  );
}

function RevealImage({
  src,
  alt,
  position,
  isActive,
  onHoverStart,
  className,
}: {
  src: string;
  alt: string;
  position: "left" | "right";
  isActive: boolean;
  onHoverStart: () => void;
  className?: string;
}) {
  return (
    <div className={clsx("tw-relative tw-col-span-2 tw-overflow-hidden tw-row-start-1 tw-pt-6", className)}>
      <RevealImageContainer position={position} isActive={isActive} onHoverStart={onHoverStart} maskEndOpacity={0.5}>
        <NextImage
          src={src}
          alt={alt}
          width={1200}
          height={900}
          className='tw-w-full tw-h-auto'
          sizes={sizes("60vw")}
        />
      </RevealImageContainer>
    </div>
  );
}
